import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './FloatingCart.css';

const FloatingCart = ({ cartItems, SetData }) => {
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const itemCount = cartItems ? cartItems.reduce((acc, item) => acc + (Number(item.productQuantity) || 1), 0) : 0;
    const subtotal = cartItems ? cartItems.reduce((acc, item) => acc + (Number(item.productQuantity) || 1) * item.productPrice, 0) : 0;

    // Lock body scroll when cart is open
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
            document.body.style.position = 'fixed';
            document.body.style.width = '100%';
        } else {
            document.body.style.overflow = '';
            document.body.style.position = '';
            document.body.style.width = '';
        }
        
        return () => {
            document.body.style.overflow = '';
            document.body.style.position = '';
            document.body.style.width = '';
        };
    }, [isOpen]);

    const toggleCart = () => {
        setIsOpen(!isOpen);
    };

    const goToCheckout = () => {
        navigate('/checkout');
        setIsOpen(false);
    };

    const handleRemoveItem = (index) => {
        SetData((prevData) => {
            const updatedCart = prevData.Cart.filter((_, i) => i !== index);
            localStorage.setItem('thinktwice_cart', JSON.stringify(updatedCart));
            return { ...prevData, Cart: updatedCart };
        });
    };

    if (itemCount === 0) return null;

    return (
        <>
            <div className="floating-cart" onClick={toggleCart}>
                <div className="cart-icon-container">
                    <i className="bi bi-cart-fill"></i>
                    <span className="cart-badge">{itemCount}</span>
                </div>
                <span className="cart-label">Cart</span>
            </div>

            {isOpen && (
                <>
                    <div className="cart-overlay" onClick={toggleCart}></div>
                    <div className="cart-drawer">
                        <div className="cart-drawer-header">
                            <h3>Shopping Cart ({itemCount} items)</h3>
                            <button className="close-btn" onClick={toggleCart}>
                                <i className="bi bi-x-lg"></i>
                            </button>
                        </div>
                        <div className="cart-drawer-body">
                            {cartItems.map((item, index) => (
                                <div key={index} className="cart-drawer-item">
                                    <img src={item.productImg} alt={item.productName} />
                                    <div className="item-info">
                                        <h4>{item.productName}</h4>
                                        <p>KSh {item.productPrice.toLocaleString()} x {item.productQuantity}</p>
                                    </div>
                                    <div className="item-actions">
                                        <span className="item-total">
                                            KSh {(item.productPrice * item.productQuantity).toLocaleString()}
                                        </span>
                                        <button 
                                            className="remove-item-btn" 
                                            onClick={() => handleRemoveItem(index)}
                                            title="Remove item"
                                        >
                                            <i className="bi bi-trash"></i>
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="cart-drawer-footer">
                            <div className="subtotal">
                                <span>Subtotal:</span>
                                <span>KSh {subtotal.toLocaleString()}</span>
                            </div>
                            <button className="btn-checkout" onClick={goToCheckout}>
                                Proceed to Checkout
                            </button>
                            <button className="btn-view-cart" onClick={() => { navigate('/cart'); setIsOpen(false); }}>
                                View Full Cart
                            </button>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default FloatingCart;
